<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
          <b-button
            v-if="$can('create','packages')"
            variant="success"
            @click="createButtonClicked"
          >
            {{ $t('Create package') }}
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <packages-list
      v-else
      :fields="fields"
      :items="items"
      :additional-data="additionalData"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../../common/mixins/list'
import PackagesList from '../../../components/admin/packages/list/PackagesList'

export default {
  components: {
    PackagesList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'packages',
      adminFields: [
        {
          key: 'id',
          label: this.$t('Id'),
        },
        {
          key: 'name',
          label: this.$t('Name'),
        },
        {
          key: 'period',
          label: this.$t('Period'),
        },
        {
          key: 'price_amount',
          label: this.$t('Price'),
        },
        {
          key: 'discount',
          label: this.$t('Discount'),
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
}
</script>

<style lang="scss">

</style>
